// Fixed, public quote templates. Never accept arbitrary supplier URLs or prices.
const requests = {
  occasion: { part: "Moteur d’occasion", reference: "", message: "Rubrique moteurs Easy Pièces — moteur d’occasion. Compatibilité, kilométrage, accessoires inclus et garantie à confirmer sur devis." },
  "echange-standard": { part: "Moteur en échange standard", reference: "", message: "Rubrique moteurs Easy Pièces — échange standard. Compatibilité, garantie et éventuelle consigne / reprise de l’ancien moteur à confirmer sur devis." },
  "citroen-16-hdi": { vehicleType: "car", brand: "Citroën", engine: "1.6 HDi", part: "Moteur Citroën 1.6 HDi — échange standard", reference: "0135HV", message: "Rubrique moteurs Easy Pièces — exemple : moteur Citroën 1.6 HDi en échange standard, référence d’origine 0135HV. Compatibilité, prix rendu, garantie et éventuelle consigne à vérifier avant devis." },
};

export function getEngineRequest(search) {
  const key = new URLSearchParams(search).get("moteur");
  return Object.prototype.hasOwnProperty.call(requests, key) ? { ...requests[key] } : null;
}

export function engineRequestUrl(key) {
  if (!Object.prototype.hasOwnProperty.call(requests, key)) throw new Error("Unknown engine request");
  return `/?moteur=${encodeURIComponent(key)}#demande-pl-tp`;
}
